import { callApi } from "Apis";
import { INFORMATIONURL } from "helpers/constant";

export async function getAboutUsById(id) {
  try {
    const response = await callApi({ url: INFORMATIONURL.GET, method: "GET" });
    return response;
  } catch (err) {
    throw err;
  }
}

export async function updateAboutUs(data) {
  try {
    const response = await callApi({ url: INFORMATIONURL.UPDATE, body: data, method: "PUT" });
    return response;
  } catch (err) {
    throw err;
  }
}
